<template>
  <div class="awards-top-section__wrapper full-width-section">
    <div class="awards-top-section__container">
      <h1 class="main-title uppercase">
        RECOGNITION. VISIBILITY.
        <a-visibility :show="true" :on="[$breakpoint.tablet]">
          <br />
        </a-visibility>
        CREDIBILITY.
      </h1>

      <h2 class="secondary-title uppercase">
        <slot name="title">Nominations now open</slot>
      </h2>

      <p class="awards-top-section__winners-announced">
        Winners will be announced on the 6th of November
      </p>

      <slot name="button">
        <awards-top-section-nominate-button />
      </slot>
    </div>
  </div>
</template>

<script>
import { ASPECT_RATIO } from 'enums/aspectRatios'
import AwardsTopSectionNominateButton from 'sections/_shared/AwardsTopSection/AwardsTopSectionNominateButton'

export default {
  name: 'AwardsTopSection',
  components: { AwardsTopSectionNominateButton },
  consts: {
    ASPECT_RATIO
  }
}
</script>

<style lang="scss" scoped>
.awards-top-section__wrapper {
  text-align: center;

  position: relative;
  background-image: url('/images/voting/hero-background.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;

  $padding: (
    $above-desktop-xl: 192px $padding-x-desktop-full-hd 192px,
    $desktop-sm: 100px $padding-x-desktop-sm 100px,
    $tablet: 64px,
    $mobile: 165px $padding-x-mobile
  );

  $min-height: (
    $above-desktop-xl: 700px,
    $mobile: unset
  );

  @include setStyleByBreakpoint('min-height', $min-height);
  @include setStyleByBreakpoint('padding', $padding);

  .awards-top-section__container {
    max-width: 1260px;
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  .secondary-title {
    $margin-top: (
      $above-desktop-xl: 32px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .awards-top-section__winners-announced {
    color: $c--white;
    text-align: center;
    font-weight: 400;

    $font-size: (
      $above-desktop-xl: 32px,
      $tablet: 20px
    );

    $margin-top: (
      $above-desktop-xl: 32px
    );

    $line-height: (
      $above-desktop-xl: 32px,
      $tablet: 30px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('line-height', $line-height);
  }
}
</style>
